module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av537-a1d59e7b05442470464f30622f59f467.jpg";